import { Component, OnInit } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';
import { Observable } from 'rxjs';

import { Alert } from '@app/core/domain';
import { AlertFacade } from '@app/core/app-services';

@Component({
  selector: 'ingo-alerts-container',
  styleUrls: ['./alerts-container.component.scss'],
  template: `
    <div class="alerts-container">
      <div class="alerts-inner-container">
        <ingo-alert
          [id]="alert.id"
          [type]="alert.type"
          [message]="alert.message"
          *ngFor="let alert of alerts$ | async"
          [@fadeInOut]="">
        </ingo-alert>
      </div>
    </div>`,
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [style({opacity: 0}), animate('200ms ease-in')]),
      transition(':leave', [animate('400ms ease-out', style({opacity: 0}))])
    ])
  ]
})
export class AlertsContainerComponent implements OnInit {

  alerts$: Observable<Array<Alert>>;

  constructor(private alertFacade: AlertFacade) { }

  ngOnInit() {
    this.alerts$ = this.alertFacade.getAlerts();
  }
}
